var _circle, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeleteIcons(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    fill: "url(#paint0_linear_829_179)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_829_179)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.25 26.0606H43.75C43.75 25.0962 43.3549 24.1713 42.6517 23.4893C41.9484 22.8074 40.9946 22.4242 40 22.4242C39.0054 22.4242 38.0516 22.8074 37.3483 23.4893C36.6451 24.1713 36.25 25.0962 36.25 26.0606ZM33.75 26.0606C33.75 24.4532 34.4085 22.9117 35.5806 21.7751C36.7527 20.6385 38.3424 20 40 20C41.6576 20 43.2473 20.6385 44.4194 21.7751C45.5915 22.9117 46.25 24.4532 46.25 26.0606H58.75C59.0815 26.0606 59.3995 26.1883 59.6339 26.4156C59.8683 26.6429 60 26.9513 60 27.2727C60 27.5942 59.8683 27.9025 59.6339 28.1298C59.3995 28.3571 59.0815 28.4848 58.75 28.4848H56.115L53.13 53.5612C52.919 55.3338 52.0433 56.9693 50.6697 58.1565C49.296 59.3438 47.5201 59.9999 45.68 60H34.32C32.4799 59.9999 30.704 59.3438 29.3303 58.1565C27.9567 56.9693 27.081 55.3338 26.87 53.5612L23.885 28.4848H21.25C20.9185 28.4848 20.6005 28.3571 20.3661 28.1298C20.1317 27.9025 20 27.5942 20 27.2727C20 26.9513 20.1317 26.6429 20.3661 26.4156C20.6005 26.1883 20.9185 26.0606 21.25 26.0606H33.75ZM37.5 35.7576C37.5 35.4361 37.3683 35.1278 37.1339 34.9005C36.8995 34.6732 36.5815 34.5455 36.25 34.5455C35.9185 34.5455 35.6005 34.6732 35.3661 34.9005C35.1317 35.1278 35 35.4361 35 35.7576V50.303C35 50.6245 35.1317 50.9328 35.3661 51.1601C35.6005 51.3874 35.9185 51.5152 36.25 51.5152C36.5815 51.5152 36.8995 51.3874 37.1339 51.1601C37.3683 50.9328 37.5 50.6245 37.5 50.303V35.7576ZM43.75 34.5455C43.4185 34.5455 43.1005 34.6732 42.8661 34.9005C42.6317 35.1278 42.5 35.4361 42.5 35.7576V50.303C42.5 50.6245 42.6317 50.9328 42.8661 51.1601C43.1005 51.3874 43.4185 51.5152 43.75 51.5152C44.0815 51.5152 44.3995 51.3874 44.6339 51.1601C44.8683 50.9328 45 50.6245 45 50.303V35.7576C45 35.4361 44.8683 35.1278 44.6339 34.9005C44.3995 34.6732 44.0815 34.5455 43.75 34.5455Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_829_179",
    x1: 40,
    y1: 0,
    x2: 40,
    y2: 80,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BA1F1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#771414"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_829_179"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(20 20)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcons);
export default __webpack_public_path__ + "static/media/delete-icons.8ad23ea85a629f1c71b0491a41978cf5.svg";
export { ForwardRef as ReactComponent };